import { useState } from "react";

import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";

import FaqCollapse from "../FaqCollapse";
import Helpers from "../../commons/helpers";

interface FAQ {
    id: string;
    question: string;
    anwser: string;
}

interface IProps {
    title: string;
    description: string;
    fqa: FAQ[];
}

const Faq = ({ title, description, fqa }: IProps) => {
    const [collapse, setCollapse] = useState<number | boolean>(false);

    return (
        <Box mt={8} mb={6}>
            <Grid container justifyContent="center">
                <Grid item xs={12} md={8}>
                    <Typography variant="h2" align="center" fontWeight="bold" gutterBottom>
                        {title}
                    </Typography>
                    <Box mb={2}>
                        <Typography variant="body2" align="center" color="text">
                            {description}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} md={10}>
                    {fqa.map((item, index) => {
                        return (
                            <FaqCollapse
                                key={index}
                                title={item.question}
                                open={collapse === index}
                                onClick={() => (collapse === index ? setCollapse(false) : setCollapse(index))}
                            >
                                {Helpers.stringToHTML(item.anwser)}
                            </FaqCollapse>
                        )
                    })}
                </Grid>
            </Grid>
        </Box>
    );
}

export default Faq;
